import config from "../../config";

export default function addConfig(state = config) {
  return state;
}
